import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
import SectionHeader from './../../components/sectionHeader'
// import Hero from '../components/hero'

const EmployerBrandingPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Employer Branding | ' + data.siteTitle.siteMetadata.title}
        meta={[
          {
            name: 'description',
            content:
              'Employer Branding overriding description but not keywords.',
          },
        ]}
      />

      <SectionHeader
        {...{
          h1: 'Employee Branding Landing Page',
          theme: 'hero dark',
        }}
      />
    </Layout>
  )
}

export const query = graphql`
  query {
    disclaimerData: disclaimerJson(tags: { in: ["homepage-index"] }) {
      title
      disclaimers {
        copy
        order
      }
    }
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default EmployerBrandingPage
